import { useId, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ label, value, onChange, autoComplete, testid, error, describedBy, name }) {
  const [show, setShow] = useState(false);
  const id = useId();
  return (
    <div>
      <label htmlFor={id} className="eyebrow block mb-2">{label}</label>
      <div className="relative">
        <input
          id={id}
          name={name}
          data-testid={testid}
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required
          aria-invalid={error ? "true" : undefined}
          aria-describedby={describedBy}
          className="w-full h-14 pl-4 pr-14 rounded-xl bg-[#1A1222] border border-[#33264A] text-[#EDE6F7] text-lg placeholder:text-[#8C84A0] focus:outline-none focus:border-[#8B2CFF] focus:ring-2 focus:ring-[rgba(139,44,255,0.35)] transition-colors"
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}
          aria-pressed={show}
          aria-controls={id}
          data-testid={`${testid}-toggle`}
          className="absolute right-1.5 top-1/2 -translate-y-1/2 h-11 w-11 rounded-lg flex items-center justify-center text-[#A49CB8] hover:text-[#B57BFF] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#8B2CFF] transition-colors"
        >
          {show ? <EyeOff className="h-5 w-5" aria-hidden="true" /> : <Eye className="h-5 w-5" aria-hidden="true" />}
        </button>
      </div>
    </div>
  );
}
